import React, { useState } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Container from "@/components/ui/Container";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { usePageTitle } from "@/hooks/usePageTitle";

const ProductsPage = () => {
  usePageTitle("Продукты");
  const [activeCategory, setActiveCategory] = useState("all");

  const categories = [
    { id: "all", name: "Все продукты" },
    { id: "inventory", name: "Управление запасами" },
    { id: "retail", name: "Ритейл" },
    { id: "logistics", name: "Логистика" },
    { id: "loyalty", name: "Лояльность" },
    { id: "payments", name: "Платежи" }
  ];

  const products = [
    {
      id: "sa-inventory",
      name: "SA Inventory",
      description: "Система управления товарными запасами для ритейла и e-commerce. Оптимизирует процессы закупок, хранения и учета товаров.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8.5"></path>
          <path d="M2 12v2a2 2 0 0 0 2 2h4"></path>
          <path d="M2 6v6"></path>
          <path d="M18 18h0"></path>
          <path d="M6 15v0"></path>
          <path d="M12 13V7a1 1 0 0 0-1-1H7"></path>
          <path d="M3 3l18 18"></path>
        </svg>
      ),
      category: "inventory",
      features: [
        "Прогнозирование спроса",
        "Автоматические заказы",
        "Мониторинг запасов в реальном времени",
        "Аналитика и отчеты"
      ]
    },
    {
      id: "sa-retail",
      name: "SA Retail",
      description: "Комплексное решение для управления розничным бизнесом. Включает управление магазинами, продажами и персоналом.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path>
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
          <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path>
          <path d="M2 7h20"></path>
          <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7"></path>
        </svg>
      ),
      category: "retail",
      features: [
        "Управление магазинами",
        "Аналитика продаж",
        "Управление персоналом",
        "Интеграция с кассами"
      ]
    },
    {
      id: "",
      name: "SA Delivery",
      description: "Система управления доставкой для e-commerce и логистических компаний. Оптимизирует маршруты и ускоряет доставку.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v12l-2 2H7l-2-2Z"></path>
          <path d="M5 12H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2"></path>
          <path d="M9 3v3"></path>
          <path d="M15 3v3"></path>
          <path d="M15 16a1 1 0 1 0 2 0 1 1 0 1 0-2 0Z"></path>
          <path d="M7 16a1 1 0 1 0 2 0 1 1 0 1 0-2 0Z"></path>
        </svg>
      ),
      category: "logistics",
      features: [
        "Оптимизация маршрутов",
        "Отслеживание в реальном времени",
        "Автоматические уведомления",
        "Интеграция с CRM"
      ]
    },
    {
      id: "",
      name: "Secret Card",
      description: "Платформа для управления системами лояльности и подарочными картами. Повышает удержание клиентов и увеличивает средний чек.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="20" height="14" x="2" y="5" rx="2"></rect>
          <line x1="2" x2="22" y1="10" y2="10"></line>
        </svg>
      ),
      category: "loyalty",
      features: [
        "Управление подарочными картами",
        "Программы лояльности",
        "Персонализированные акции",
        "Аналитика поведения клиентов"
      ]
    },
    {
      id: "POSS",
      name: "POSS",
      description: "Современная POS-система для приема платежей и управления продажами. Поддерживает различные способы оплаты и интеграции.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="18" x="3" y="3" rx="2"></rect>
          <circle cx="9" cy="9" r="2"></circle>
          <path d="M15 9h.01"></path>
          <path d="M15 15h.01"></path>
          <path d="M9 15h.01"></path>
        </svg>
      ),
      category: "payments",
      features: [
        "Различные способы оплаты",
        "Интеграция с 1С",
        "Учет склада",
        "Программы лояльности"
      ]
    },
    {
      id: "",
      name: "FH.BY",
      description: "Решение для интернет-магазинов с единым backend, сайтом и мобильным приложением. Удобная административная панель обеспечивает полный контроль над бизнес-процессами.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path>
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
          <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path>
          <path d="M2 7h20"></path>
          <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7"></path>
        </svg>
      ),
      category: "retail",
      features: [
        "Единый бэкенд для сайта и приложения",
        "Удобное управление товарами и заказами",
        "Интеграция с платежными системами",
        "Аналитика продаж и трафика"
      ]
    }
  ];

  const filteredProducts = activeCategory === "all" 
    ? products 
    : products.filter(product => product.category === activeCategory);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-20 bg-secondary">
         
          <Container>
            <div className="max-w-3xl mx-auto text-center">
              <div className="tag mb-6 animate-fade-in">Наши продукты</div>
              <h1 className="heading text-4xl md:text-5xl font-bold mb-6 animate-fade-in" style={{ animationDelay: "0.2s" }}>
                Инновационные <span className="text-gradient">программные решения</span> для вашего бизнеса
              </h1>
              <p className="text-muted-foreground text-lg mb-0 animate-fade-in" style={{ animationDelay: "0.4s" }}>
                Мы разрабатываем программное обеспечение, которое помогает оптимизировать процессы, повышать эффективность и увеличивать прибыльность бизнеса.
              </p>
            </div>
          </Container>
        </section>

        {/* Products Section */}
        <section className="py-20">
          <Container>
            {/* Filter */}
            <div className="flex overflow-x-auto pb-4 mb-12 -mx-4 px-4 sm:justify-center sm:pb-0">
              <div className="flex space-x-2">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setActiveCategory(category.id)}
                    className={`px-4 py-2 rounded-full whitespace-nowrap transition-colors ${
                      activeCategory === category.id
                        ? "bg-primary text-white"
                        : "bg-secondary text-foreground hover:bg-primary/10"
                    }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Products Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProducts.map((product) => (
                <div 
                  key={product.id} 
                  className="relative group bg-white rounded-2xl p-6 shadow-sm border border-border hover:border-primary/20 hover:shadow-md transition-all duration-300"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity duration-300"></div>
                  <div className="relative z-10">
                    <div className="w-12 h-12 bg-secondary flex items-center justify-center rounded-lg mb-5 text-primary">
                      {product.icon}
                    </div>
                    <div className="tag mb-3">{categories.find(c => c.id === product.category)?.name}</div>
                    <h3 className="text-xl font-semibold mb-3">{product.name}</h3>
                    <p className="text-muted-foreground mb-5 text-sm">{product.description}</p>
                    
                    <div className="mb-5">
                      <h4 className="text-sm font-medium mb-2">Ключевые особенности:</h4>
                      <ul className="space-y-1">
                        {product.features.map((feature, idx) => (
                          <li key={idx} className="flex items-start text-sm">
                            <span className="text-primary mr-2">•</span>
                            <span className="text-muted-foreground">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    {product.id && (
                    <Link to={`/products/${product.id}`} className="inline-flex items-center text-primary font-medium">
                      Подробнее
                      <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                    </Link>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-secondary">
          <Container>
            <div className="glass rounded-2xl p-8 md:p-12">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <h2 className="heading text-3xl font-bold mb-4">
                    Не нашли подходящего решения?
                  </h2>
                  <p className="text-muted-foreground mb-6">
                    Мы разрабатываем индивидуальные решения под конкретные задачи и потребности вашего бизнеса. Свяжитесь с нами, чтобы обсудить ваш проект!
                  </p>
                  <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                    <Link to="/services" className="button-secondary">
                      Наши услуги
                    </Link>
                    <Link to="/contact" className="button-primary">
                      Связаться с нами
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </div>
                </div>
                <div className="relative">
                  <div className="h-auto bg-white/5 rounded-2xl overflow-hidden p-6">
                    <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?q=80&w=2670')] bg-cover bg-center opacity-10 rounded-2xl"></div>
                    <div className="relative h-full flex flex-col items-center justify-center text-center space-y-4">
                      <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                          <path d="M11 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5.5"></path>
                          <path d="M18 14v4h4"></path>
                          <path d="M18 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"></path>
                          <path d="M15 12v-2"></path>
                          <path d="M17 10v2"></path>
                          <path d="M19 12v-2"></path>
                          <path d="M21 10v2"></path>
                        </svg>
                      </div>
                      <h3 className="text-2xl font-semibold">Индивидуальные решения</h3>
                      <p className="text-muted-foreground">
                        Разрабатываем программное обеспечение с учетом специфики вашего бизнеса и уникальных требований.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ProductsPage;
